import { Injectable } from '@angular/core';
import { environment as env } from '../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { StorageService } from './storage.service';
import { HttpService } from './http.service';
import { API_AUTH_LOGIN, API_AUTH_LOGOUT, LOGIN_ROUTE } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(
    private router: Router,
    private http: HttpClient,
    private storageService: StorageService,
    private httpService: HttpService
  ) {}

  login(email: string, password: string): Observable<object> {
    return this.httpService.post(env.baseUrl + API_AUTH_LOGIN, { email, password });
  }

  logout(): void {
    this.storageService.clearStorage();
    this.router.navigate([LOGIN_ROUTE]);
  }

  forgotPassword(email: string): Observable<object> {
    return this.httpService.post(env.baseUrl + '/forgot-password', { email });
  }

  getUserProfile(): Observable<any> {
    return this.http.get<any>(env.baseUrl + `/profile`);
  }

  updateProfile(request: any): Observable<any> {
    return this.http.post<any>(env.baseUrl + `/profile`, request);
  }

  changePassword(request: any): Observable<object> {
    return this.httpService.put(env.baseUrl + '/update-password', request);
  }

  resetPassword(request: any): Observable<object> {
    return this.httpService.post(env.baseUrl + '/reset-password', request);
  }

  logoutApi(): Observable<object> {
    return this.httpService.post(env.baseUrl + API_AUTH_LOGOUT, {});
  }

  getUser() {
    return this.storageService.getFromLocalOrSessionStorage('user');
  }

  getRole() {
    const user = this.getUser();
    return user ? user.role : 'User undefined'; // Restituisce il ruolo dell'utente
  }
}
